import Loader from "components/Loader";
import getModuleName from "utils/getModuleName";
import "./table.css";
import Tooltip from "components/Tooltip";

export default function Table(props) {
   
   const {
      heading,
      columns: rawColumns,
      data: rawData,
      loading,
      footer
   } = props;

   const module = getModuleName();
   const columns = Array.isArray(rawColumns) ? rawColumns : [];
   const data = Array.isArray(rawData) ? rawData : [];

   const renderHeading = () => {
      if (!heading) return null;

      if (module === "UD" && typeof heading === "string") {
         const parts = heading.includes("|")
            ? heading.split("|").map((part) => part.trim()).filter(Boolean)
            : [heading.trim()].filter(Boolean);
         if (parts.length === 0) return null;
         const HEADING_MAIN_EM = "0.95em";
         const HEADING_SUB_EM = "0.88em";
         return (
            <div className="table-heading-split" style={{ marginBottom: "12px" }}>
               {parts.map((part, index) => {
                  const isMain = index === 0 && parts.length > 1;
                  return (
                  <div
                     key={index}
                     style={{
                        fontSize: isMain ? HEADING_MAIN_EM : HEADING_SUB_EM,
                        fontWeight: isMain ? "600" : "500",
                        lineHeight: isMain ? "1.28" : "1.2",
                        marginBottom: index < parts.length - 1 ? "2px" : "0"
                     }}
                  >
                     {part}
                  </div>
                  );
               })}
            </div>
         );
      }

      return <h3>{heading}</h3>;
   };

   return (
      <div className="table-wrap">
         {renderHeading()}

         <table className="table" role="table" aria-label={heading || "Tabela danych"}>
            <thead>
               <tr>
                  {columns.map(({ name, label, align, tooltip, width }, i) => {
                     return (
                        <th
                           key={String(name ?? label) + i}
                           style={{ textAlign: align, width: width ? width + "px" : undefined }}
                        >
                           <span
                              style={{
                                 cursor: name ? "pointer" : undefined,
                                 display: name ? "flex" : undefined,
                                 justifyContent: name ? align : undefined
                              }}
                           >
                              {label}
                              {tooltip && <Tooltip text={tooltip} />}
                           </span>
                        </th>
                     );
                  })}
               </tr>
            </thead>

            <tbody>
               {!loading && data.length > 0 &&
                  data.map((item, rowIndex) => {

                     const rowKey = item && ("id" in item) ? `row-${item.id}` : `row-${rowIndex}`;

                     return (
                        <tr key={rowKey}>
                           {columns.map(({ name, render, label }, colIndex) => {
                              const cellKey = String(name ?? colIndex);
                              let cellContent = "";
                              if (typeof render === "function") {
                                 try {
                                    cellContent = render(item, rowIndex);
                                 } catch (err) {
                                    console.error("Table cell render error:", err);
                                    cellContent = "";
                                 }
                              } else {
                                 cellContent = item ? (item[name] ?? "") : "";
                              }

                              return (
                                 <td key={cellKey}>
                                    <div className="table-td-column">{label}</div>
                                    {cellContent}
                                 </td>
                              );
                           })}
                        </tr>
                     );
                  })}
            </tbody>

            {!loading && data.length > 0 && footer && (
               <tfoot>
                  <tr>
                     {footer.map((item, i) => (
                        <td key={i}>
                           {typeof item === "object" && item !== null ? JSON.stringify(item) : item}
                        </td>
                     ))}
                  </tr>
               </tfoot>
            )}
         </table>

         {!loading && data && !data.length && (
            <div style={{ padding: "30px 0", textAlign: "center" }}>Brak wyników!</div>
         )}

         {loading && <Loader height={120} />}
      </div>
   );
}